import { FC } from 'react';
import { Button, Modal } from 'antd';
import './style.less';

interface IConfirmProps {
  onOk?: () => void;
  onClose?: () => void;
  open?: boolean;
  isClose?: boolean;
  message?: string;
}

const Confirm: FC<IConfirmProps> = (props) => {
  const {open, onOk, onClose, isClose = true, message = '是否取消？'} = props;
  return <Modal footer={null} closeIcon={false} open={open} wrapClassName={'confirm_modal'}>
    <div className="modal_body">
      {message}
    </div>
    <div className="modal_footer">
      {isClose && <Button className="operate" onClick={() => onClose?.()}>取消</Button>}
      <Button className="operate confirm" onClick={() => onOk?.()}>确定</Button>
    </div>
  </Modal>;
};
export default Confirm;
